export default "__VITE_ASSET__a48fca7b__"